import cn from 'clsx';
import PropTypes from 'prop-types';
import styles from './button.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Button({
  color,
  className,
  children,
  ...restProps
}) {
  return /*#__PURE__*/_jsx("button", {
    className: cn(styles.btn, {
      [styles[`btn--${color}`]]: color
    }, className),
    ...restProps,
    children: children
  });
}
Button.propTypes = {
  children: PropTypes.any,
  color: PropTypes.oneOf(['primary', 'success']),
  className: PropTypes.string
};